export default __webpack_public_path__ + "static/media/coal.5d429102.svg";